import React, { useContext, useState, useEffect, Fragment } from "react";

import AlertContext from "../../context/alert/alertContext";
import AuthContext from "../../context/auth/authContext";

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: '100%',
      maxWidth: 400,
    },
  },
}));

const Login = (props) => {
  const classes = useStyles();

  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);

  const { setAlert } = alertContext;
  const { login, message, clearAuthMessages, isAuthenticated } = authContext;

  // Check if already logged in — only on mount.
  useEffect(() => {
    if (authContext.token) {
      authContext.loadUser();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push("/destinations");
    }
    if (message) {
      setAlert(message, "error");
      clearAuthMessages();
    }
    // eslint-disable-next-line
  }, [message, isAuthenticated, props.history]);

  const [user, setUser] = useState({
    user_id: "",
    password: "",
  });

  const { user_id, password } = user;

  const onChange = (e) => setUser({ ...user, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    let isSuccess = true;
    if (user_id === "" || password === "") {
      setAlert("Please enter all fields", "error");
      isSuccess = false;
    }
    if (isSuccess) {
      login({
        user_id,
        password,
      });
    }
  };
  return (
    <Fragment>
      <br />
      <br />
      <Grid container>
        <Grid size={{ xs: 1, sm: 2, lg: 3 }}></Grid>
        <Grid size={{ xs: 10, sm: 8, lg: 6 }}>
          <h1>Login</h1>
          <form
            className={classes.root}
            noValidate
            autoComplete="off"
            onSubmit={onSubmit}
          >
            <div>
              <TextField
                required
                id="standard-required"
                label="User ID"
                name="user_id"
                value={user_id}
                onChange={onChange}
                fullWidth
              />
            </div>
            <div>
              <TextField
                required
                id="standard-password-input"
                label="Password"
                type="password"
                autoComplete="current-password"
                name="password"
                value={password}
                onChange={onChange}
                fullWidth
              />
            </div>
            <br />
            <div>
              <Button
                type="submit"
                value="Login"
                variant="contained"
                color="primary"
                style={{ background: "#03a9f4" }}
              >
                Login
              </Button>
            </div>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Don't have an account? <Link to="/register">Register</Link>
            </Typography>
          </form>
        </Grid>
        <Grid size={{ xs: 1, sm: 2, lg: 3 }}></Grid>
      </Grid>
    </Fragment>
  );
};

export default Login;
